import BranchesList from './BranchesList';
import BranchesReplace from './BranchesReplace';
import BranchItem from './BranchItem/BranchItem';

export {
  BranchesList,
  BranchesReplace,
  BranchItem,
};



// WEBPACK FOOTER //
// ./src/components/Branches/index.js